import { useState } from "react";
import { Link } from "react-router-dom";
import { faqList } from "@/mocks/faq";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="max-w-portal mx-auto px-4 md:px-6 pt-12 md:pt-16 scroll-mt-28">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
        <div className="lg:col-span-1">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-[0.2em] text-accent-700 uppercase">
            <span className="w-6 h-px bg-accent-500" aria-hidden="true" />
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mt-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 leading-relaxed mt-3">
            关于内容来源、更新节奏与投稿方式，这里先回答最常见的几个疑问。还有别的问题？
          </p>
          <Link
            to="/about#contact"
            className="inline-flex items-center gap-1.5 mt-5 px-4 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-accent-700 transition-colors"
          >
            <i className="ri-question-answer-line w-4 h-4 flex items-center justify-center" />
            联系我们
          </Link>
        </div>

        <div className="lg:col-span-2">
          <div className="divide-y divide-background-200 border-y border-background-200">
            {faqList.map((item, idx) => {
              const open = openIndex === idx;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : idx)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-4 py-4 text-left cursor-pointer group"
                  >
                    <span className="flex items-start gap-3">
                      <span className="font-heading font-black text-sm text-primary-700 mt-0.5">
                        Q{idx + 1}
                      </span>
                      <span className="font-heading text-base font-bold text-foreground-950 group-hover:text-accent-700 transition-colors">
                        {item.q}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 w-6 h-6 flex items-center justify-center text-foreground-500 transition-transform ${
                        open ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    />
                  </button>
                  {open ? (
                    <p className="pb-5 pl-9 pr-4 text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}